/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 14:28:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-20 10:12:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/common.ts
 */
import { generateCollapse } from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export enum EnumCollapseId {
  hotTags = 'saleChannelContentProductSearchHotTags',
  searchBar = 'saleChannelContentProductSearchSearchBar',
  featuredProducts = 'saleChannelContentProductFeaturedProducts',
  miniProgramShare = 'saleChannelContentHomepageMiniProgramShare',
  miniProgramPageInfo = 'saleChannelContentHomepageMiniProgramInfo',
}
export const fixedCollapse = [
  EnumCollapseId.hotTags,
  EnumCollapseId.searchBar,
  EnumCollapseId.featuredProducts,
  EnumCollapseId.miniProgramShare,
  EnumCollapseId.miniProgramPageInfo,
];

export const defaultCollapse = (display?) => {
  return generateCollapse(fixedCollapse, display);
};

export const generateDefaultFeaturedProducts = () => {
  return { titleTextColor: '#000000', enabled: false };
};
export const generateDefaultSearchBar = () => {
  return { placeholder: '搜索' };
};
